export default "__VITE_ASSET__bc67a34a__"